import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { HeaderComponent } from '../../components/header/header.component';
import { ButtonComponent } from '../../components/button/button.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule, NgIf } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownService } from '../../services/dropdown.service';
import { ScriptService } from '../../services/script.service';
import { ValidationService } from '../../services/validation.service';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { AssessmentService } from '../../services/assessment.service';

@Component({
  selector: 'app-add-script-form-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, NgIf, TextInputComponent, SelectInputComponent, ReactiveFormsModule, FormsModule, FilterByKeyAndValuePipe, CommonModule],
  templateUrl: './add-script-form-page.component.html',
  styleUrl: './add-script-form-page.component.css'
})
export class AddScriptFormPageComponent {
  form: FormGroup;
  params: any = {};
  assessment: any;
  answerDirPatched: boolean = false;
  isFormInitializing: boolean = false;
  link_copied: boolean = false;
  constructor(
    public gs: GlobalService,
    public route: Router,
    public fb: FormBuilder,
    public script: ScriptService,
    public ar: ActivatedRoute,
    public dds: DropdownService,
    public vs: ValidationService,
    public as: AssessmentService,
  ) {
    this.form = this.fb.group({
      answer_script_directory: ['', [Validators.required]],
      no_of_pages_per_script: [{ value: '', disabled: true }],
      hide_script_pages_for_faculty: [{ value: '', disabled: true }],
      hide_script_percentage: [{ value: '', disabled: true }],
      no_of_pages_per_supplement: [{ value: '', disabled: true }],
      hide_supplement_pages_for_faculty: [{ value: '', disabled: true }],
      hide_supplement_percentage: [{ value: '', disabled: true }],
      image_prefix: ['', [Validators.required]],
      image_format: ['', [Validators.required]],
      university_id: ['', [Validators.required]],
      level_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      college_id: ['', [Validators.required]],
      academic_year_id: ['', [Validators.required]],
      exam_id: ['', [Validators.required]],
      subject_id: ['', [Validators.required]],
      is_active: [true],
      check: [true]
    });

  }

  async ngOnInit() {
    await this.dds?.get_dropdown_list(['exam', 'university', 'subject', 'academic-year', 'assessment', 'assess']);
    await this.dds.refresh_dropdown_list(['subject', 'assess', 'assessment']);

    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params };
      if (this.params.id) {
        await this.patch_form_data(this.params.id);
      }
    });

    this.form.valueChanges.subscribe(async values => {
      const { university_id, exam_id, subject_id, academic_year_id } = values;
      const university = this.dds.dropdown_list?.university_list?.find((x: any) => x.value == university_id);
      const academic_year = this.dds.dropdown_list?.academic_list?.find((x: any) => x.value == academic_year_id);
      const exam = this.dds.dropdown_list?.exam_list?.find((x: any) => x.value == exam_id);
      const assessment = this.dds.dropdown_list?.assessment_list?.find((x: any) =>
        x.exam_id == values.exam_id &&
        x.university_id == values.university_id &&
        x.subject_id == values.subject_id &&
        x.academic_year_id == values.academic_year_id
      );

      if (assessment != undefined) {
        this.form.patchValue(
          { answer_script_directory: `${academic_year?.name}/${university?.code}/${assessment?.college?.code}/${assessment?.level?.code}/${assessment?.program?.code}/${assessment?.stream?.code}/${assessment?.exam?.code}/${assessment.subject?.code}` },
          { emitEvent: false },
        );
        this.answerDirPatched = true;
        this.form.patchValue({ program_id: assessment?.program_id }, { emitEvent: false });
        this.form.patchValue({ level_id: assessment?.level_id }, { emitEvent: false });
        this.form.patchValue({ stream_id: assessment?.stream_id }, { emitEvent: false });
        this.form.patchValue({ college_id: assessment?.college_id }, { emitEvent: false });
        this.assessment = assessment;

        // Fetch script config for this assessment and prefill
        try {
          const res = await this.as.get(assessment.id, {});
          const sc = res?.data?.script_config;
          if (sc) {
            this.form.patchValue({
              no_of_pages_per_script: sc.no_of_pages_per_script || '',
              hide_script_pages_for_faculty: sc.hide_script_pages_for_faculty || '',
              hide_script_percentage: sc.hide_script_percentage || '',
              no_of_pages_per_supplement: sc.no_of_pages_per_supplement || '',
              hide_supplement_pages_for_faculty: sc.hide_supplement_pages_for_faculty || '',
              hide_supplement_percentage: sc.hide_supplement_percentage || '',
            }, { emitEvent: false });
          }
        } catch {}
      } else {
        this.form.patchValue({ answer_script_directory: '' }, { emitEvent: false });
        this.answerDirPatched = false;
      }
    });
  }

  async patch_form_data(id: any) {
    this.isFormInitializing = true;
    let response = await this.script.get(id);
    let data = response.data;

    this.form.patchValue({
      ...data,
      academic_year_id: data.Assessment?.AcademicYear?.id,
      university_id: data.Assessment?.University?.id,
      exam_id: data.Assessment?.Exam?.id,
      level_id: data.Assessment?.level_id,
      program_id: data.Assessment?.program_id,
      stream_id: data.Assessment?.stream_id,
      college_id: data.Assessment?.college_id,
    }, { emitEvent: false });

    setTimeout(() => {
      this.form.patchValue({ subject_id: data?.Assessment?.Subject?.id }, { emitEvent: true });
      this.isFormInitializing = false;
    }, 0);
  }

  async create_directory() {
    if (!this.answerDirPatched) return;
    this.answerDirPatched = false;
    if (!this.params.id) {
      await this.script.create_directory({ assessment_id: this.assessment.id });
    }
  }

  async check_submit() {
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    try {
      let form_value = this.form.getRawValue();
      form_value.is_active = true;
      form_value.check = true;
      let res = await this.script.add(form_value);
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async submit() {
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    try {
      let form_value = this.form.getRawValue();
      form_value.is_active = true;
      form_value.check = false;
      if (this.params.id) {
        await this.script.add(form_value);
        this.gs.toastr_shows_function('Script Updated Successfully', 'Success', 'success');
      } else {
        let create_response = await this.script.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.route.navigate(['/add-script/list'], { queryParams: { university_id: this.form.value.university_id, academic_year_id: this.form.value.academic_year_id, exam_id: this.form.value.exam_id, subject_id: this.form.value.subject_id } });
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  copy_directory() {
    const dir = this.form.get('answer_script_directory')?.value;
    if (dir) {
      navigator.clipboard.writeText(dir);
      this.link_copied = true;
      setTimeout(() => { this.link_copied = false; }, 2000);
    }
  }

  isFormatSelected(format: string): boolean {
    const formats: string[] = this.form.get('image_format')?.value || [];
    return Array.isArray(formats) && formats.includes(format);
  }

  toggleImageFormat(format: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    let formats: string[] = Array.isArray(this.form.get('image_format')?.value)
      ? [...this.form.get('image_format')?.value]
      : [];
    if (checked) {
      if (!formats.includes(format)) formats.push(format);
    } else {
      formats = formats.filter(f => f !== format);
    }
    this.form.patchValue({ image_format: formats });
    this.form.get('image_format')?.markAsDirty();
    this.form.get('image_format')?.markAsTouched();
  }

  change_hide_supplement_percentage_value() {
    if (this.form.value.hide_supplement_pages_for_faculty == 0 || this.form.value.hide_supplement_pages_for_faculty == '0') {
      this.form.patchValue({ hide_supplement_percentage: 0 });
    }
  }

  maxValueValidator(compareControlName: string) {
    return (control: any) => {
      if (!control.value || !this.form) return null;
      const compareControl = this.form.get(compareControlName);
      if (!compareControl || !compareControl.value) return null;
      const currentValue = parseInt(control.value);
      const maxValue = parseInt(compareControl.value);
      if (isNaN(currentValue) || isNaN(maxValue)) return null;
      if (currentValue > maxValue) {
        return { maxValue: { max: maxValue, actual: currentValue, message: `Cannot be greater than ${maxValue}` } };
      }
      return null;
    };
  }
}
